/** @jsxImportSource @emotion/react */
import { Card, CardContent, Typography, useTheme, Box } from '@mui/material'
import PersonOffIcon from '@mui/icons-material/PersonOff'
import { cardTitle, metricCard } from '../styles/Admin.styles'

interface TotalUsersCardProps {
  count: number
  title: string
}

export const AdminPendingInvitesCard = ({ count, title }: TotalUsersCardProps) => {
  const theme = useTheme()

  return (
    <Card css={metricCard()}>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            mb: 1,
          }}
        >
          <Typography variant="subtitle2" css={cardTitle}>
            {title}
          </Typography>

          <PersonOffIcon
            sx={{
              color: theme.palette.warning.main,
              opacity: 1,
              fontSize: 28,
            }}
          />
        </Box>

        <Typography variant="h5" fontWeight={700} css={cardTitle}>
          {count ?? '-'}
        </Typography>

        <Typography variant="body2" color="text.secondary">
          Users who have pending invites to access Rex for this client
        </Typography>
      </CardContent>
    </Card>
  )
}
